import { createRouter, createWebHistory } from "vue-router";
import Home from "@/components/pages/Home";
import AboutUs from "@/components/pages/AboutUs";
import ContactUs from "@/components/pages/ContactUs";
import PrivacyPolicy from "@/components/pages/PrivacyPolicy";
import Alta from "@/components/pages/Alta";
import { eventBus } from "../eventBus";
import Leadership from "@/components/pages/Leadership.vue";
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "PGP Title - Homepage",
        metaTags: [
          {
            name: "description",
            content: "The Homepage of PGP Title",
          },
          {
            property: "og:description",
            content: "The Homepage of PGP Title",
          },
        ],
      },
    },
    {
      path: "/CompanyInformation",
      name: "Company Information",
      component: AboutUs,
      meta: {
        title: "PGP Title - Company Information",
      },
    },
    {
      path: "/ContactUs/:state",
      name: "Contact Us",
      component: ContactUs,
      meta: {
        title: "PGP Title - Contact Us",
      },
    },
    {
      path: "/ContactUs",
      name: "ContactUs",
      component: ContactUs,
      meta: {
        title: "PGP Title - Contact Us",
      },
    },
    {
      path: "/PrivacyPolicy",
      name: "Privacy Policy",
      component: PrivacyPolicy,
      meta: {
        title: "PGP Title - Privacy Policy",
      },
    },
    {
      path: "/Alta",
      name: "Alta",
      component: Alta,
      meta: {
        title: "PGP Title - Compliance",
      },
    },
    {
      path: "/Leadership",
      name: "Leadership",
      component: Leadership,
      meta: {
        title: "PGP Title - Leadership",
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash };
    }
    return { left: 0, top: 0 };
  },
});

router.afterEach((to) => {
  eventBus.$emit("routeChangedEvent", to);
  setTimeout(() => {
    eventBus.$emit("routeChangedEvent", to);
  }, 100);
});

export default router;
